import { Component, ElementRef, forwardRef, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { TextInputComponent } from '../text-input/text-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NO_PAGINATION } from 'src/app/model/pagination.options';
import { SelectOption } from '../../model/select.option';
import { MatSelectChange } from '@angular/material/select';
import { AdminService } from 'src/app/service/admin.service';
import { EventTitlePipe } from 'src/app/pipe/event.title.pipe';
import { Event } from 'src/app/model/event';
import { EventsService } from 'src/app/service/events.service';

@Component({
  selector: 'app-select-input-le',
  templateUrl: './select-input-le.component.html',
  styleUrls: ['./select-input-le.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectInputLoadEventComponent),
    multi: true
  }]
})

export class SelectInputLoadEventComponent extends TextInputComponent implements OnInit {
  @Input() options: Array<SelectOption> = [];
  @Input() indices = {
    internal: 'id',
    public: 'value'
  };

  @Input() prependPublic = '';
  @Output() selectionChange: EventEmitter<MatSelectChange> = new EventEmitter<MatSelectChange>();

  @Input() multiple = false;
  @Input() eventId: Number;

  @Input() compact = false;
  @Input() includeNoneOption = false;

  event: Event;
  subEventsID: Array<number>;

  @Input() isEditable: boolean = true;
  /** panelClass do mat-select — auto-injetado como `jems3-select-panel`
   *  quando o host tem `.filter-styled` (via ngOnInit). */
  @Input() panelClass = '';

  /* eslint-disable constructor-super */
  /* @ts-ignore */
  constructor(
    private adminService: AdminService,
    private eventsService: EventsService,
    private elementRef: ElementRef,
  ) {
    super();
  }

  ngOnInit(): void {
    const formControl = this.formGroupController.get(this.name);
    this.isEditable ? formControl.enable() : formControl.disable();
    // Chrome JEMS3 auto-injetado globalmente (rollout Nível 1); consumer pode
    // sobrescrever passando `panelClass` explícito.
    if (!this.panelClass) {
      this.panelClass = 'jems3-select-panel';
    }
    this.loadEvents();
  }

  loadEvents(): void {
    this.adminService.getEvent().subscribe(event => {
      this.event = event;
      this.getSubEvents();
    });
  }

  private getSubEvents(): void {
    this.eventsService.getAllSubEvents(this.event.id)
      .subscribe({
        next: subEvents => this.subEventsID = subEvents.map(subEvent => subEvent.id),
        complete: () => {
          this.createOptions(); // Only fetch events if options not given
        }
      })
  }
    
  private createOptions(): void {
    this.eventsService.getAllEventsWithMinimumDetails()
      .subscribe(events => {
        const newOptions = events
          .filter(event => (event['id'] !== this.event.id))
          .sort((a, b) => `${a.acronym} ${a.year} - ${a.name}`.localeCompare(`${b.acronym} ${b.year} ${b.name}`))
          .map(event => new SelectOption(event.id, `${event.acronym} ${event.year} - ${event.name}`));
        
          this.options = [...newOptions];
      });
  }

  public isEventRelative(eventID: number): boolean {
    return this.subEventsID?.includes(eventID);
  }

  onSelection($event: MatSelectChange): void {
    this.selectionChange.emit($event);
  }
}
